import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import { Row } from './Row';
import './Select.scss';
const Caret = require('./caret.png');

interface SelectProps {
  value: string;
  open: boolean;
  getScrollOffsetForLetter(letter: string): number;
  onOpen();
  onClose();
}

class SelectUnwrapped extends React.PureComponent<SelectProps, {}> {
  public containerRef;
  public dropdownRef;

  constructor(props) {
    super(props);

    this.containerRef = React.createRef();
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    this.containerRef.current.addEventListener('keydown', (e) => {
      if (this.props.open) {
        const top = this.props.getScrollOffsetForLetter(e.key.toLowerCase());
        this.dropdownRef.current.scroll({ top });
      }
    });
  }

  handleClickOutside() {
    this.props.onClose();
  }

  renderDropdown() {
    return (
      <div ref={this.dropdownRef} className='multiple-select-dropdown'>
        {this.props.children}
      </div>
    );
  }

  render() {
    return (
      <div ref={this.containerRef} tabIndex={0} className='multiple-select-container'>
        <div className='multiple-select d-flex h-100 align-items-end' onClick={this.props.onOpen}>
          <span>{this.props.value}</span>
          <img src={Caret} className='multiple-select-caret' />
        </div>
        {this.props.open && this.renderDropdown()}
      </div>
    );
  }
}

export const Select = onClickOutside(SelectUnwrapped);
Select.Row = Row;
Select.Separator = () => {
  return <div className='multiple-select-separator' />;
};
